import { isDomainError, isValidationPayload } from "@repo/api";
import { toast } from "sonner";

/** Global tRPC toast boundary; preserve server/domain errors and their original messages. */
export function showTRPCError(error: unknown): void {
  if (!isDomainError(error)) return;
  if (error.data?.code === "BAD_REQUEST" && isValidationPayload(error.message)) {
    console.error("tRPC input validation failed", error);
    toast.error("Some information is invalid. Please review your changes and try again.");
    return;
  }
  toast.error(error.message);
}
